import { t } from "../../../../../utils/i18n";
import React from "react";
import { cardImages } from "../../New/helpers";
import {
  CardRequestData,
  getStatusIconConfig,
  formatCardType,
  formatStatus,
  getFallbackCardImage,
} from "./helpers";
import "./index.scss";

interface Props {
  cardRequest: CardRequestData;
}

const CardRequest: React.FC<Props> = ({ cardRequest }) => {
  const cardImageUrl =
    cardImages[cardRequest.card_type] || getFallbackCardImage();
  const cardTypeDisplay = formatCardType(cardRequest.card_type);
  const statusDisplay = formatStatus(cardRequest.status);
  const statusConfig = getStatusIconConfig(cardRequest.status);

  return (
    <div className="col-md-6 col-lg-4 mb-4">
      <div className="modern-card-container modern-fade-in h-100 d-flex flex-column">
        <div
          className="modern-card-header"
          style={{ background: "var(--primary-color, #4c3f84)" }}
        >
          <i className="fa fa-inbox" />
          <h5>{t("cards.requests.card_request_caps")}</h5>
        </div>

        <img
          src={cardImageUrl}
          alt={t("cards.requests.card_request_alt", { type: cardTypeDisplay })}
          className="mt-3"
          style={{
            width: "100%",
            height: "180px",
            objectFit: "contain",
            backgroundColor: "#ffffff",
          }}
        />

        <div className="modern-card-body flex-grow-1 d-flex flex-column">
          <div className="mb-3">
            <p className="text-muted mb-1" style={{ fontSize: "0.8rem" }}>
              {t("cards.requests.card_type_caps")}
            </p>
            <h5 className="font-weight-bold">{cardTypeDisplay}</h5>
          </div>

          <div className="mb-3">
            <p className="text-muted mb-1" style={{ fontSize: "0.8rem" }}>
              {t("cards.requests.name_on_card_caps")}
            </p>
            <p className="font-weight-bold">
              {cardRequest.name_on_card || t("cards.common.not_available")}
            </p>
          </div>

          <div className="mb-4">
            <p className="text-muted mb-1" style={{ fontSize: "0.8rem" }}>
              {t("cards.details.status_caps")}
            </p>
            <span
              style={{
                color: "var(--text-dark, #2d3436)",
                fontSize: "0.9rem",
                fontWeight: "500",
              }}
            >
              <i
                className={`fa ${statusConfig.icon}`}
                style={{
                  marginRight: "0.5rem",
                  color: statusConfig.color,
                }}
              />
              {statusDisplay}
            </span>
          </div>

          <div className="mt-auto">
            <a
              className="modern-btn modern-btn-primary w-100"
              href={`/cards/requests/${cardRequest.id}`}
            >
              {t("cards.requests.view_details")}
              <i className="fa fa-arrow-right-long" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardRequest;
